import {handleApiCall} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/number'
// Modules
import number from './number'
import revisions from './revisions'
import toolbox from './toolbox'
import billings from './billings'

const initialState = () => ({
    numbers: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        numbers: state => state.numbers.data,
        pagination: state => state.numbers.pagination
    },
    actions: {
        listNumbers: ({commit, dispatch}, data) => handleApiCall({commit, dispatch}, api.listNumbers, data, mutationTypes.SET_NUMBERS, true),
        resetNumbers: ({commit}) => commit(mutationTypes.RESET_NUMBERS)
    },
    modules: {
        number,
        billings,
        revisions,
        toolbox
    },
    mutations: {
        [mutationTypes.RESET_NUMBERS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_NUMBERS]: (state, data) => state.numbers = data
    }
}
